import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute, useLinkProps } from '@tanstack/react-router';
import { LoginWidget } from '~/components/auth/LoginWidget';
import { LegacyLoginWidget } from '~/components/auth/LegacyLoginWidget';
import { useV3Redesign } from '~/helper/useV3Redesign';

const VALIANT_COMPANY_ID = '145859503298';
const DEFAULT_COMPANY_ID = '70927429839';

export const Route = createFileRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_LOGIN as any,
)({
  component: function Body() {
    const params = Route.useParams();
    const v3Redesign = useV3Redesign();
    const Widget = v3Redesign ? LoginWidget : LegacyLoginWidget;
    const isValiant = params.companyId === VALIANT_COMPANY_ID;

    const { href: dashboardUrl } = useLinkProps({
      to: AppRoute.$LANG_$COMPANYID_INDEX as any,
      params: isValiant ? { ...params, companyId: DEFAULT_COMPANY_ID } : params,
    });

    return (
      <Widget
        dashboardUrl={dashboardUrl}
        initialSSOView={isValiant}
      />
    );
  },
});
